export const apiEndpoint =
  process.env.REACT_APP_API_ENDPOINT ?? "http://localhost:7071/api";
